module.exports = __webpack_public_path__ + "static/img/cv.825501fd.svg";